export const urlcampaign = `${process.env.NEXT_PUBLIC_API_URL}/api/v1/campaign`
export const urlaccount = `${process.env.NEXT_PUBLIC_API_URL}/api/v1/user/account`
export const urlpresents = `${process.env.NEXT_PUBLIC_API_URL}/api/v1/presents`
export const urlpresentitem = `${process.env.NEXT_PUBLIC_API_URL}/api/v1/present/item`
export const urluserpresentGetItem = `${process.env.NEXT_PUBLIC_API_URL}/api/v1/user/present`
export const urluserpresentsItem = `${process.env.NEXT_PUBLIC_API_URL}/api/v1/user/presents`
export const urlregister = `${process.env.NEXT_PUBLIC_API_URL}/api/v1/register`
export const urlspots = `${process.env.NEXT_PUBLIC_API_URL}/api/v1/spots`
export const urlsheets = `${process.env.NEXT_PUBLIC_API_URL}/api/v1/user/sheets`
export const urlsheets01 = `${process.env.NEXT_PUBLIC_API_URL}/api/v1/sheets`
export const urlstamps = `${process.env.NEXT_PUBLIC_API_URL}/api/v1/stamps`
export const urlcoupons = `${process.env.NEXT_PUBLIC_API_URL}/api/v1/coupons`
export const urldelstamps = `${process.env.NEXT_PUBLIC_API_URL}/api/v1/user/stamps`
export const urlnotifications = `${process.env.NEXT_PUBLIC_API_URL}/api/v1/notifications`
export const urlquestionnairesanswer = `${process.env.NEXT_PUBLIC_API_URL}/api/v1/questionnaires/answer/type`
export const urlquestionnairestype = `${process.env.NEXT_PUBLIC_API_URL}/api/v1/questionnaires/type`
export const urlinquiry = `${process.env.NEXT_PUBLIC_API_URL}/api/v1/inquiry`
export const urlinquiries = `${process.env.NEXT_PUBLIC_API_URL}/api/v1/inquiries`
export const urlmenu = `${process.env.NEXT_PUBLIC_API_URL}/api/v1/menus`
export const tokenraund = `${process.env.NEXT_PUBLIC_RAUND_TOKEN}`
